import React from "react";
import KeyInsights from "./KeyInsights";

const KeyInsightsSection = (props) => {
  const { keyInsights, companyId = null, detailedData = [], role, type = null, assetId = null, testId = null, containerClass = '' } = props;

  return (
    <div className="grid grid-cols-12 ctem-key-insights">
        <div className='col-span-12 sm:col-span-12'>
          <KeyInsights
            companyId={companyId}
            data={keyInsights} 
            detailedData={detailedData}
            role={role}
            type={type}
            assetId={assetId}
            testId={testId}
            containerClass={containerClass}
          />
        </div>
    </div>
  );
};

export default KeyInsightsSection;
